module.exports = __webpack_public_path__ + "img/arrow_right_blue.svg";